import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M30.763 18.194c.35-.327.81-.49 1.292-.455a1.73 1.73 0 0 1 1.58 1.58c.05.706-.329 1.36-.963 1.667-1.677.811-2.735 2.556-2.696 4.445.047 2.243 1.44 3.518 2.669 4.379l17.478 13.716-.002-.009 4.823-1.292L35.07 26.628l-.095-.07c-.988-.686-.993-.964-.998-1.21-.008-.33.165-.629.437-.76a5.692 5.692 0 0 0 3.213-5.544 5.725 5.725 0 0 0-5.296-5.296 5.734 5.734 0 0 0-4.296 1.522 5.73 5.73 0 0 0-1.815 4.175h4c0-.48.193-.924.544-1.251ZM50.147 43.614H13.518l15.89-13.839-2.628-3.016L9.003 42.242a3.038 3.038 0 0 0-.856 3.384 3.038 3.038 0 0 0 2.868 1.988h40.204l-1.072-4Z"
      }
    )
  }
);
export {
  c as Cloakroom
};
